import { UFOExperience } from '@atlassian/ufo';
import type { ExperienceConfig } from '@atlassian/ufo-experimental/types';
import { Experience, EXPERIENCE_CONFIGS } from './constants';

interface UFOExperienceOptions {
    experience: Experience;
    config?: ExperienceConfig;
}

// ref from AFM: post-office/platform/packages/navigation/atlassian-switcher/src/common/utils/experience-tracker/experience-store.ts
export class ExperienceStore {
    private readonly ufoExperiences = new Map<string, UFOExperience>();
    private readonly commonExperienceConfig: ExperienceConfig | undefined;

    constructor(config?: ExperienceConfig) {
        this.commonExperienceConfig = config;
    }

    private getExperienceConfig(experience: Experience) {
        const targetConfig = EXPERIENCE_CONFIGS[experience];
        if (!targetConfig) {
            return EXPERIENCE_CONFIGS[Experience.RENDER_UNKNOWN_ELEMENT];
        }
        return targetConfig;
    }

    createNewUFOExperience(experienceOptions: UFOExperienceOptions) {
        const targetConfig = this.getExperienceConfig(experienceOptions.experience);
        return new UFOExperience(targetConfig.experienceId, {
            ...targetConfig.config,
            ...this.commonExperienceConfig,
            ...experienceOptions.config,
        });
    }

    getOrCreateUFOExperience(experienceOptions: UFOExperienceOptions) {
        const targetConfig = this.getExperienceConfig(experienceOptions.experience);
        if (!this.ufoExperiences.has(targetConfig.experienceId)) {
            this.ufoExperiences.set(targetConfig.experienceId, this.createNewUFOExperience(experienceOptions));
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this.ufoExperiences.get(targetConfig.experienceId)!;
    }

    get(experienceId: string) {
        return this.ufoExperiences.get(experienceId);
    }

    getAll() {
        return Array.from(this.ufoExperiences.values());
    }
}
